export class AppConfiguration {
  hbAPI: string;
  gbmAPI: string;
  userPreferencesApi: string;
  applicationId: number;
  deviceId: number;
  solace: any;
  timeOuts: any;
  reports: any;
  ujet: any;
}

export interface AppConfigurationApis {
  loremApi: string;
  newsApi: string;
  gbmComApi: string;
  tradingUsaApi: string;
  priceAlertsApi: string;
  api: string;
  appId: string;
  comBankAccountUrl: string;
  comBlackUpgrade: string;
  deviceId: string;
  ujetAuthUrl: string;
}
